import { render } from "./toggleButton.vue?vue&type=template&id=3a986dec&scoped=true"
import script from "./toggleButton.vue?vue&type=script&lang=js"
export * from "./toggleButton.vue?vue&type=script&lang=js"

import "./toggleButton.vue?vue&type=style&index=0&id=3a986dec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a986dec"]])

export default __exports__